// extracted by mini-css-extract-plugin
export default {"placeholderDateText":"Filters_placeholderDateText__WPYn2","pageDevider":"Filters_pageDevider__z13ph"};